import { css, keyframes } from "styled-components";

/* A soft ring of violet fire spinning around a pill button, and a halo behind it (the publish button's, the
   domain checkout's). The wrapper takes `fireRingWrapper`; inside it, before the button:
   <span className="fire-halo" /><span className="fire-ring" /> */
const spin = keyframes`
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

const fireRing = css`
  position: absolute;
  overflow: hidden;
  pointer-events: none;
  border-radius: 100px;

  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200vmax;
    max-width: 1200px;
    aspect-ratio: 1;
    content: "";
    background: conic-gradient(
      rgba(220, 205, 255, 0.55),
      rgba(178, 140, 255, 0.4) 10%,
      rgba(122, 75, 255, 0.2) 20%,
      rgba(75, 16, 255, 0) 32%,
      rgba(75, 16, 255, 0) 68%,
      rgba(122, 75, 255, 0.2) 80%,
      rgba(178, 140, 255, 0.4) 90%,
      rgba(220, 205, 255, 0.55)
    );
    transform: translate(-50%, -50%);
    animation: ${spin} 5s linear infinite;
  }
`;

export const fireRingWrapper = css`
  position: relative;
  isolation: isolate;
  padding: 1px;

  .fire-ring {
    ${fireRing}
    inset: 0;
    z-index: -1;
  }

  .fire-halo {
    ${fireRing}
    inset: -4px;
    z-index: -2;
    opacity: 0.35;
    filter: blur(10px);
  }

  @media (prefers-reduced-motion: reduce) {
    .fire-ring::before,
    .fire-halo::before {
      animation: none;
    }
  }
`;
